package org.multiplatform.kotfolio.util

import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.PersistentList
import kotlinx.collections.immutable.persistentListOf
import kotlinx.collections.immutable.persistentMapOf
import kotlinx.collections.immutable.toImmutableList
import kotlinx.collections.immutable.toPersistentList
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow
import org.multiplatform.kotfolio.domain.Blog
import org.multiplatform.kotfolio.domain.Language
import org.multiplatform.kotfolio.domain.Topic
import org.multiplatform.kotfolio.models.BlogEnum

class BlogsRepository {
    private val languageList = listOf(
        Language("programming", "Programming"),
        Language("kid", "Kid"),
        Language("listing", "Flipkart"),
    )

    private val topicList = listOf(
        //PROGRAMMING
        Topic("java", "Java", "programming"),
        Topic("android_studio", "Android Studio", "programming"),
        Topic("flutter", "Flutter", "programming"),
        Topic("kotlin", "Kotlin", "programming"),
        Topic("coroutines", "Coroutines", "programming"),
        Topic("jetpack_compose", "Jetpack Compose", "programming"),
        Topic("kotlin_multiplatform", "Kotlin Multiplatform", "programming"),
        Topic("kobweb", "Kobweb", "programming"),
        Topic("wasm", "WASM", "programming"),
        Topic("kotlin_react", "Kotlin React", "programming"),
        Topic("kotlin_notebook", "Kotlin Notebook", "programming"),
        Topic("react", "React", "programming"),

        //KID
        Topic("kid", "All", "kid"),

        //LISTING
        Topic("listing", "Listing", "listing"),
    )

    private val tracks = persistentMapOf(
        "android_studio" to listOf(
            Blog(
                1,
                "",
                links = listOf("Gradle" to Constants.GRADLE_URL),
                blogEnum = BlogEnum.GradleAndroidStudio
            ),
        ),

        "java" to listOf(
            Blog(1, "", links = listOf("Inheritance" to Constants.JAVA_INHERITANCE_URL), blogEnum = BlogEnum.InheritanceJava),
            Blog(2, "", links = listOf("Abstract class" to Constants.JAVA_ABSTRACT_CLASS_URL), blogEnum = BlogEnum.AbstractClassJava),
            Blog(3, "", links = listOf("Multithreading" to Constants.JAVA_THREAD_URL), blogEnum = BlogEnum.MultithreadingJava),
            Blog(4, "", links = listOf("Java Difference" to "https://docs.google.com/document/d/17nWvgEqZdVKJp0Lyv1-4MaEeL6Dp1BGs/edit?usp=sharing&ouid=102675730981417844297&rtpof=true&sd=true"), blogEnum = BlogEnum.DifferenceJava)
        ),

        "flutter" to listOf(
            Blog(1, "", links = listOf("Basic" to Flutter.WIDGET_ARCHITECTURE_URL), blogEnum = BlogEnum.BasicFlutter),
            Blog(2, "", links = listOf("Main Widget" to Flutter.WIDGET_LIFECYCLE_URL), blogEnum = BlogEnum.MainWidgetFlutter),
            Blog(3, "", links = listOf("Clean Architecture, Solid design structure" to Flutter.CLEAN_ARCHITECTURE_URL), blogEnum = BlogEnum.CleanArchitectureFlutter),
            Blog(4, "", links = listOf("BLoC State Management" to Flutter.BLOC_URL), blogEnum = BlogEnum.BLoCStateManagementFlutter),
            Blog(5, "", links = listOf("Riverpod State Management" to "https://medium.com/@kamal.lakhani56/riverpod-state-management-flutter-8b4f303c27c2"), blogEnum = BlogEnum.RiverPodManagementFlutter),
            Blog(6, "", links = listOf("GetX State Management" to Flutter.GETX_URL), blogEnum = BlogEnum.GetXStateManagementFlutter),
            Blog(7, "", links = listOf("get_it - Dependency Injection" to Flutter.GET_IT_DI_URL), blogEnum = BlogEnum.DependencyInjectionFlutter),
            Blog(8, "", links = listOf("freezed annotation" to Flutter.FREEZED_URL), blogEnum = BlogEnum.FreezedAnnotationFlutter),
            Blog(9, "", links = listOf("Asynchronous" to Flutter.ASYNCHRONOUS_URL), blogEnum = BlogEnum.AsynchronousFlutter),
            Blog(10, "", links = listOf("Isolate" to Flutter.ISOLATE_URL), blogEnum = BlogEnum.IsolateFlutter),
            Blog(11, "", links = listOf("Channel communication" to Flutter.PLUGIN_URL), blogEnum = BlogEnum.ChannelCommunicationFlutter),
            Blog(12, "", links = listOf("Interview question - 123" to Flutter.INTERVIEW_QUESTIONS_URL), blogEnum = BlogEnum.QuestionsFlutter)
        ),

        "kotlin" to listOf(
            Blog(1, "", links = listOf("Design Patterns" to Kotlin.DESIGN_PATTERNS_URL), blogEnum = BlogEnum.DesignPatternKotlin),
            Blog(2, "", links = listOf("Interview question - 237+" to Kotlin.QUESTIONS_URL), blogEnum = BlogEnum.QuestionsKotlin),
            Blog(3, "", links = listOf("Higher Order Functions (HOF)" to Kotlin.HIGHER_ORDER_FUNCTIONS_URL), blogEnum = BlogEnum.HOFKotlin),
            Blog(4, "", links = listOf("Filter Collection() - 57" to Kotlin.FILTER_COLLECTION_URL), blogEnum = BlogEnum.FilterCollectionKotlin),
            Blog(5, "", links = listOf("Race condition, Volatile, atomic, synchronized, Mutex (Latest way)" to Kotlin.MUTEX_URL), blogEnum = BlogEnum.RaceConditionKotlin),
            Blog(6, "", links = listOf("New Feature" to Kotlin.KotlinNewFeature.NEW_FEATURE_URL), blogEnum = BlogEnum.NewFeatureKotlin),
        ),

        "notebook" to listOf(
            Blog(1, "", links = listOf("Kotlin Notebook" to Kotlin.NOTE_BOOK_URL), blogEnum = BlogEnum.NotebookKotlin),
        ),

        "coroutines" to listOf(
            Blog(1,"", links = listOf("Coroutines" to Coroutines.BASIC_URL), blogEnum = BlogEnum.BasicCoroutines),
            Blog(2,"", links = listOf("Suspending function, Coroutine Builder" to Coroutines.CREATE_URL), blogEnum = BlogEnum.SuspendingFunctionsCoroutines),
            Blog(3,"", links = listOf("Dispatchers" to Coroutines.DISPATCHERS_URL), blogEnum = BlogEnum.DispatchersCoroutines),
            Blog(4,"", links = listOf("Flow Basic, Create, Builders, flowOn() Operator, Combine Flow, Combine | Zip | Filter programmatically" to Coroutines.FLOW_BASIC_URL), blogEnum = BlogEnum.FlowBasicCoroutines),
            Blog(5,"", links = listOf("StateFlow and SharedFlow" to Coroutines.STATE_SHARED_FLOW_URL), blogEnum = BlogEnum.StateSharedFlowCoroutines),
            Blog(6,"", links = listOf("stateIn and shareIn" to Coroutines.CONVERT_FLOW_URL), blogEnum = BlogEnum.StateShareInCoroutines),
            Blog(7,"", links = listOf("Coroutine scope, context, exception handling (Throws, CoroutineExceptionHandler, continuation.resumeWithException()), callback, suspendCancellableCoroutine, suspendCoroutine and Channel Communication" to Coroutines.CONTEXT_CANCELLATION_URL), blogEnum = BlogEnum.ScopeCoroutines),
            Blog(8,"", links = listOf("Semaphore parallelism" to Coroutines.SEMAPHORE_URL), blogEnum = BlogEnum.SemaphoreCoroutines),
            Blog(9,"", links = listOf("Interview question - 160" to Coroutines.QUESTIONS_URL), blogEnum = BlogEnum.QuestionsCoroutines),
        ),

        "jetpack_compose" to listOf(
            Blog(1, "", links = listOf("Basic" to JetpackCompose.BASIC_URL), blogEnum = BlogEnum.BasicJC),
            Blog(2, "", links = listOf("Modifiers" to JetpackCompose.MODIFIER_URL),  blogEnum = BlogEnum.ModifiersJC),
            Blog(3, "", links = listOf("Composable lifecycle" to JetpackCompose.LIFE_CYCLE_URL), blogEnum = BlogEnum.ComposeLifeCycleJC),
            Blog(4, "", links = listOf("Unidirectional data flow (UDF)" to JetpackCompose.UDF_URL), blogEnum = BlogEnum.DataFlowJC),
            Blog(5, "", links = listOf("State Hosting (Local State and Hoist State)" to JetpackCompose.STATE_HOSTING_URL), blogEnum = BlogEnum.StateHostingJC),
            Blog(6, "", links = listOf("Scoped Slots (Composable Slotting)" to JetpackCompose.SCOPED_SLOTS_URL), blogEnum = BlogEnum.ScopedSlotsJC),
            Blog(7, "", links = listOf("Internal Render Process" to JetpackCompose.INTERNAL_RENDER_PROCESS_URL), blogEnum = BlogEnum.InternalRenderProcessJC),
            Blog(8, "", links = listOf("State Manage Compose" to JetpackCompose.STATE_MANAGE_URL), blogEnum = BlogEnum.StateManageJC),
            Blog(9, "", links = listOf("Common wrapper state, Sandwich" to Constants.COMMON_WRAPPER_URL), blogEnum = BlogEnum.WrapperStateJC),
            Blog(10, "", links = listOf("Stability" to JetpackCompose.SideEffect.STABILITY_URL), blogEnum = BlogEnum.StabilityJC),
            Blog(11, "", links = listOf("Side effect / Effect handler" to JetpackCompose.SideEffect.SIDE_EFFECT_URL), blogEnum = BlogEnum.EffectHandlerJC),
            Blog(12, "", links = listOf("CompositionLocal" to JetpackCompose.COMPOSITIONAL_LOCALS_URL), blogEnum = BlogEnum.CompositionLocalJC),
            Blog(13, "", links = listOf("ViewModel" to JetpackCompose.VIEWMODEL_URL), blogEnum = BlogEnum.ViewModelJC),
            Blog(14, "", links = listOf("Navigation" to JetpackCompose.NAVIGATION_URL), blogEnum = BlogEnum.NavigationJC),
            Blog(15, "", links = listOf("Pagination" to JetpackCompose.PAGINATION_URL), blogEnum = BlogEnum.PaginationJC),
            Blog(16, "", links = listOf("Animation" to JetpackCompose.ANIMATION_URL), blogEnum = BlogEnum.AnimationJC),
            Blog(17, "", links = listOf("Hilt" to Constants.HILT_DI_URL), blogEnum = BlogEnum.HiltJC),
            Blog(18, "", links = listOf("Basic, Koin, Annotations, Navigation" to Constants.KOIN_BASIC_URL), blogEnum = BlogEnum.KoinJC),
            Blog(20, "", links = listOf("Room database" to Constants.ROOM_DATABASE_URL), blogEnum = BlogEnum.RoodDBJC),
            Blog(21, "", links = listOf("Preferences dataStore" to JetpackCompose.PREF_STORE_URL), blogEnum = BlogEnum.DataStoreJC),
            Blog(22, "", links = listOf("KTOR" to Constants.KTOR_URL), blogEnum = BlogEnum.KToRJC),
            Blog(23, "", links = listOf("MVVM, Clean Architecture" to Constants.CLEAN_ARCHITECTURE_COMPOSE_URL), blogEnum = BlogEnum.CleanArchitectureJC),
            Blog(24, "", links = listOf("MVI" to Constants.CLEAN_ARCHITECTURE_COMPOSE_MVI_URL), blogEnum = BlogEnum.MVIJC),
            Blog(26, "", links = listOf("Search (Combine | Zip | Search | Filter)" to Coroutines.FILTER_URL), blogEnum = BlogEnum.FilterCoroutines),
            Blog(27, "", links = listOf("kotest" to Constants.KOTEST_URL), blogEnum = BlogEnum.KoTestJC),
            Blog(28, "", links = listOf("Interview Question - 47" to Constants.INTERVIEW_QUESTION_COMPOSE_URL), blogEnum = BlogEnum.QuestionJC),
        ),

        "kotlin_multiplatform" to listOf(
            Blog(1, "", links = listOf("Basic" to KMM.BASIC_URL), blogEnum = BlogEnum.BasicKMP),
            Blog(2, "", links = listOf("Material3 theme" to "https://medium.com/@kamal.lakhani56/kmp-material3-compose-1-6-3-69062552bc1b"), blogEnum = BlogEnum.Theme3KMP),
            Blog(3, "", links = listOf("KMP Plugin" to KMM.KMP.PLUGIN_URL), blogEnum = BlogEnum.PluginKMP),
            Blog(4, "", links = listOf("KMP Shared" to KMM.KMP.SHARED_VIEWMODEL_URL), blogEnum = BlogEnum.SharedPluginKMP),
            Blog(5, "", links = listOf("Preference" to KMM.KMP.SECURE_STORAGE_URL), blogEnum = BlogEnum.PreferenceKMP),
            Blog(6, "", links = listOf("Constraint" to KMM.KMP.CONSTRAINT_LOGIN_URL), blogEnum = BlogEnum.ConstraintKMP),
            Blog(7, "", links = listOf("Realm database" to KMM.KMP.REALM_URL), blogEnum = BlogEnum.RealmDBKMP),
            Blog(8, "", links = listOf("Firebase Generic" to KMM.KMP.FIREBASE_URL), blogEnum = BlogEnum.FirebaseKMP),
        ),

        "kid" to listOf(
            Blog(1, "", links = listOf("Body" to Kids.EVS.BODY_URL), blogEnum = BlogEnum.BodyKids),
            Blog(2, "", links = listOf("Water" to Kids.EVS.WATER_URL), blogEnum = BlogEnum.WaterKids),
            Blog(3, "", links = listOf("Air" to Kids.EVS.AIR_URL), blogEnum = BlogEnum.AirKids),
            Blog(4, "", links = listOf("Stories" to Kids.EVS.STORIES_URL), blogEnum = BlogEnum.StoriesKids),
            Blog(5, "", links = listOf("Animals" to Kids.EVS.ANIMALS_URL), blogEnum = BlogEnum.AnimalsKids),
            Blog(5, "", links = listOf("Ride To Read - 2 CBSE" to ""), blogEnum = BlogEnum.RideToReader2Kids),
        ),

        "listing" to listOf(
            Blog(1, "", links = listOf("Kitchen Trolley Metal - (Listing)" to Listing.KITCHEN_TROLLEY_METAL_URL), blogEnum = BlogEnum.KitchenTrolleyListingFlipkart),
            Blog(2, "", links = listOf("Wardrobe Plastic - (Listing)" to Listing.WARDROBE_PLASTIC_URL), blogEnum = BlogEnum.WardrobePlasticListingFlipkart),
            Blog(3, "", links = listOf("Step Ladder - (Listing)" to Listing.STEP_LADDER_URL), blogEnum = BlogEnum.StepLadderListingFlipkart),
            Blog(4, "", links = listOf("Cloth Dryer - (Listing)" to Listing.CLOTH_DRYER_VERTICAL_URL), blogEnum = BlogEnum.ClothDryerListingFlipkart),
            Blog(5, "", links = listOf("Chopping Board - (Listing)" to Listing.CHOPPING_BOARD_URL), blogEnum = BlogEnum.ChoppingBoardFlipkart),
        ),
    )

    fun getLanguage(): Flow<PersistentList<Language>> = flow {
        emit(languageList.toPersistentList())
    }

    fun getTopic(languageId: String): Flow<ImmutableList<Topic>> = flow {
        emit(topicList.asSequence().filter { it.languageId == languageId }.toImmutableList())
    }

    fun getTrack(topicId: String): Flow<ImmutableList<Blog>> = flow {
        emit(tracks[topicId]?.toImmutableList() ?: persistentListOf())
    }
}
